<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="relative z-[100]" @close="emit('close')">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/50" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel class="w-full max-w-md overflow-hidden bg-white shadow-2xl">
              <div class="p-6 text-center">
                <div class="mx-auto mb-4 flex h-12 w-12 items-center justify-center bg-blue-50 text-blue-600">
                  <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <DialogTitle class="mb-3 text-lg font-medium text-gray-900">
                  {{ $t('booking.modals.photo_limit.title') }}
                </DialogTitle>
                <p class="mb-4 text-sm leading-6 text-gray-600">
                  {{ $t('booking.modals.photo_limit.description') }}
                </p>
                <div class="mb-6 border border-amber-200 bg-amber-50 px-4 py-3">
                  <p
                    data-testid="photo-limit-separate-booking"
                    class="text-sm font-semibold leading-6 text-gray-900"
                  >
                    {{ $t('booking.modals.photo_limit.separate_booking') }}
                  </p>
                </div>
                <button
                  data-testid="photo-limit-confirm"
                  type="button"
                  class="inline-flex items-center justify-center bg-gray-900 px-6 py-2.5 text-sm font-medium text-white hover:bg-gray-800"
                  @click="emit('close')"
                >
                  {{ $t('booking.modals.photo_limit.confirm') }}
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

defineProps<{ isOpen: boolean }>()
const emit = defineEmits<{ close: [] }>()
</script>
